export class valoresSeleccion {
    idValorSeleccionPk:number;
    bubCatCamposConfig:number;
    valor: string;
    descripcion: string;
    valorExtracto: string;
}